/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decision Wheel — Spin to Pick (Random Picker) — Toolverse`)
};

const es_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rueda de Decisiones — Gira para Elegir (Selector Aleatorio) — Toolverse`)
};

const de_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entscheidungsrad — Drehen und wählen lassen (Zufallsauswahl) — Toolverse`)
};

const nl_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beslisrad — Draaien om te Kiezen (Willekeurige Kiezer) — Toolverse`)
};

const fr_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roue de Décision — Tournez pour Choisir (Sélecteur Aléatoire) — Toolverse`)
};

const it_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruota della decisione — gira per scegliere (selettore casuale) — Toolverse`)
};

const pt_br2_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roleta de Decisão — Gire para Escolher (Sorteador Aleatório) — Toolverse`)
};

const pt_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roda de Decisão — Gire para Escolher (Seletor Aleatório) — Toolverse`)
};

const ja_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`決定ホイール — 回してランダムに選ぶ — Toolverse`)
};

const zh_dw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`决策转盘——转动选择（随机抽选器）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_meta_title", locale)
	if (locale === "en") return en_dw_meta_title(inputs)
	if (locale === "es") return es_dw_meta_title(inputs)
	if (locale === "de") return de_dw_meta_title(inputs)
	if (locale === "nl") return nl_dw_meta_title(inputs)
	if (locale === "fr") return fr_dw_meta_title(inputs)
	if (locale === "it") return it_dw_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_dw_meta_title(inputs)
	if (locale === "pt") return pt_dw_meta_title(inputs)
	if (locale === "ja") return ja_dw_meta_title(inputs)
	return zh_dw_meta_title(inputs)
};